import { render, staticRenderFns } from "./MenuCreditor.vue?vue&type=template&id=24bbccaa&scoped=true&"
var script = {}
import style0 from "./MenuCreditor.vue?vue&type=style&index=0&id=24bbccaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bbccaa",
  null
  
)

export default component.exports